/* unplugin-vue-components disabled */import { render } from "./PopupBindPhone.vue?vue&type=template&id=6aba326f&ts=true"
import script from "./PopupBindPhone.vue?vue&type=script&lang=ts"
export * from "./PopupBindPhone.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__